import { ITableColumn } from '@makyoapp/makyo-sdk/models/Table'

import { Cell, ICell } from '.'

export interface IImageArray extends ITableColumn {
  Settings: null
}

export interface IImageArrayCell extends ICell {
  settings: null
}

export class ImageArrayCell implements IImageArrayCell {
  value: Cell
  settings: null

  constructor(values: Cell, settings: null) {
    this.value = this.parseValue(values)
    this.settings = settings
  }

  parseValue(value: any) {
    if (typeof value === 'string') {
      try {
        let parsedValue = JSON.parse(value)
        if (Array.isArray(parsedValue)) {
          return parsedValue
        }
        return []
      } catch (e) {
        return []
      }
    }
    if (Array.isArray(value)) {
      return value
    }
    return []
  }

  toString(): string {
    // todo: convert to JSON stringify
    if (this.value === null) {
      return ''
    }

    if (typeof this.value === 'number' || typeof this.value === 'boolean') {
      return JSON.stringify(this.value)
    }

    if (this.value instanceof Date) {
      return JSON.stringify(this.value.toISOString()) // Convert Date to ISO string
    }

    return JSON.stringify(this.value) // Fallback for string type
  }

  toCell<T extends Cell>(newValue: T) {
    if (typeof newValue !== 'string') {
      return this
    }

    // Attempt to parse the string value
    let parsedValue

    try {
      parsedValue = JSON.parse(newValue)

      // Additional handling if the parsedValue should be converted to a specific type
      if (typeof parsedValue === 'string') {
        const dateValue = new Date(parsedValue)
        if (!isNaN(dateValue.getTime())) {
          parsedValue = dateValue // Convert back to Date if it was originally a Date string
        }
      }
    } catch (e) {
      // If JSON parsing fails, assume the value is a string
      parsedValue = newValue
    }

    // Return the current ImageArrayCell instance with the updated value
    this.value = parsedValue
    return this
  }
}
